<template>
  <v-row>
    <v-col cols="12">
      <v-data-table
        :headers="header"
        :items="listModality"
        no-data-text="Nenhuma Modalidade foi encontrada"
        loading-text="Carregando Modalidades..."
        class="modality-table base__datatable"
        @click:row="redirectToSubModality"
        :search="filter"
      >
        <template v-slot:[`item.nome`]="{ item }">
          <div :class="borderColor(item.ativo)">
            <div class="modality-table__padding">
              {{ item.nome }}
            </div>
          </div>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>
<script>
const tableHeaders = [
  { text: "Modalidade", value: "nome", sortable: true },
  { text: "Status", value: "status.nome", sortable: true }
];
const colorByStatus = [
  { color: "green", status: true },
  { color: "pink", status: false }
];
import { mapState } from "vuex";
export default {
  data: () => ({
    header: tableHeaders,
    listColorByStatus: colorByStatus
  }),
  computed: {
    ...mapState("modality", ["listModality"])
  },
  methods: {
    borderColor(item) {
      const status = this.listColorByStatus.find(x => x.status == item);
      return `modality-table__border-${status.color}`;
    },
    redirectToSubModality(item) {
      this.$router.push({
        name: "list sub-modality",
        params: { id: item.id }
      });
    },
    isAtive(item) {
      return item ? "Ativo" : "Inativo";
    }
  },
  props: {
    filter: {
      type: String
    }
  }
};
</script>
<style lang="sass">
.modality-table__
  &border-green
    border-left: 5px solid #49DCBB
  &border-pink
    border-left: 5px solid #EF5350
  &padding
    padding: 0px 15px !important
    height: 36px !important
    display: flex
    align-items: center
.modality-table
  tbody tr
    cursor: pointer
.modality-table.v-data-table.theme--light
  tbody tr td:first-child
    padding: 2px 0px !important
    text-align: center !important
  tbody tr td:last-of-type:not(:only-of-type)
    text-align: end !important
  thead tr th:last-child
    text-align: end !important
</style>
